module.exports = __webpack_public_path__ + "static/media/patrol(15).f1cdb0bb.PNG";